import base64 from 'base-64';

export const handlerGetLocalStorage = (name) => {
  const data = localStorage.getItem(name);
  if (data === null) {
    return null;
  }
  if (data !== null) {
    return base64.decode(data);
  }
};